export const keyboardNavigationKeys = [
  'tab',
  'enter',
  'arrowup',
  'arrowdown',
  'arrowleft',
  'arrowright',
];

export const bodyClass = 'keyboard-mode';

/**
 * This mixin is meant to be used only *once per app*,
 * ideally in the layout component.
 *
 * When the user presses any of the recognised keyboard navigation keys,
 * the mixin adds the `keyboard-mode` class to the body.
 * The class is then removed when the user clicks with their cursor.
 */
export default {
  mounted() {
    this.bodyKeyUpListener = (event) => {
      if (keyboardNavigationKeys.includes(event.key?.toLowerCase())) {
        document.body.classList.add(bodyClass);
      }
    };
    this.bodyClickListener = () => document.body.classList.remove(bodyClass);
    document.body.addEventListener('keyup', this.bodyKeyUpListener);
    document.body.addEventListener('click', this.bodyClickListener);
  },
  beforeDestroy() {
    document.body.removeEventListener('keyup', this.bodyKeyUpListener);
    document.body.removeEventListener('click', this.bodyClickListener);
  },
};
